// extracted by css-extract-rspack-plugin
module.exports =  {"button":"ScoringButton-A6Sh__button","red":"ScoringButton-krgQ__red","orange":"ScoringButton-h1i3__orange","green":"ScoringButton-rgMD__green"};